import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Walkdowns } from 'pages/walkdown/Walkdowns'

export const Route = createFileRoute('/walkdowns/{-$siteID}')({
  component: WalkdownsRouteComponent,
})

function WalkdownsRouteComponent() {
  const params = Route.useParams()
  const siteID = params.siteID

  if (!siteID) {
    return <Outlet />
  }

  return <Walkdowns />
}
